import { render, staticRenderFns } from "./WorkflowImage.vue?vue&type=template&id=bf43ba1e&scoped=true"
import script from "./WorkflowImage.vue?vue&type=script&lang=js"
export * from "./WorkflowImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf43ba1e",
  null
  
)

export default component.exports